export default __webpack_public_path__ + "static/media/envelope.5f072e0e.png";